// extracted by mini-css-extract-plugin
export default {"frame":"GeofenceMap_frame__UR33U","canvas":"GeofenceMap_canvas__k1Nas","empty":"GeofenceMap_empty__1M4ph"};